import { type PropsWithChildren, createContext, useContext, useMemo } from 'react'

import { useEntitiesContext } from 'entities/EntitiesExport'
import { RolesPermissionsStore } from '../store/RolesPermissionsStore'

const RolesPermissionsContext = createContext<RolesPermissionsStore | null>(null)

export const useRolesPermissionsContext = () => {
  const context = useContext(RolesPermissionsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with RolesPermissionsProvider')

  return context
}

export const RolesPermissionsProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new RolesPermissionsStore(entities), [])

  return (
    <RolesPermissionsContext.Provider value={store}>{children}</RolesPermissionsContext.Provider>
  )
}
